import type { CommunityDetail } from '@pba/react-network';
import { Card } from 'ui';
import { UserAvatarPopover } from 'features/users';

type P = {
  community: CommunityDetail;
};

const CommunityAdmins = ({ community }: P) => {
  if (community.administrators.length === 0) {
    return null;
  }

  return (
    <Card.HorizontalScroll
      items={community.administrators.map((administrator) => ({
        children: <UserAvatarPopover popoverProps={{ stretch: true }} user={administrator} />,
        key: administrator.id,
      }))}
      title="Admins"
    />
  );
};

export default CommunityAdmins;
